module.exports = __webpack_public_path__ + "img/ai.aicddfccf.svg";